<template>
  <div
    v-if="bannerMessage"
    class="mb-4 lg:-mt-2 lg:mb-3 rounded-xl"
    :class="bannerToneClass"
    role="status"
  >
    <div class="flex items-center justify-center gap-2 text-sm">
      <CheckCircleIcon
        v-if="bannerVariant === 'success'"
        class="w-5 h-5 text-aces flex-shrink-0"
      />
      <XCircleIcon
        v-else-if="bannerVariant === 'error'"
        class="w-5 h-5 text-error flex-shrink-0"
      />
      <ExclamationCircleIcon
        v-else
        class="w-5 h-5 text-warning flex-shrink-0"
      />
      <span class="font-medium" :class="messageClass">{{ bannerMessage }}</span>
    </div>
  </div>
</template>

<script>
  import {
    CheckCircleIcon,
    ExclamationCircleIcon,
    XCircleIcon,
  } from "@heroicons/vue/solid";
  import {
    bannerVariantForLockReason,
    messageForLockReason,
  } from "../utils/orderLockMessages";

  export default {
    name: "OrderPaidBanner",
    components: {
      CheckCircleIcon,
      ExclamationCircleIcon,
      XCircleIcon,
    },
    props: {
      lockReason: { type: String, default: null },
    },
    computed: {
      bannerVariant() {
        return bannerVariantForLockReason(this.lockReason);
      },
      bannerMessage() {
        return messageForLockReason(this.lockReason);
      },
      bannerToneClass() {
        if (this.bannerVariant === "success") return "banner-success";
        if (this.bannerVariant === "error") return "banner-error";
        return "banner-warning";
      },
      messageClass() {
        if (this.bannerVariant === "success") return "text-dark-gray";
        if (this.bannerVariant === "error") return "text-error-fg";
        return "text-warning-fg";
      },
    },
  };
</script>
